import { type IEvent } from 'clients/PlatformApi';
import { useCallback, useState } from 'react';

export interface UseArchivePanelProps {
  closeArchivePanel: () => void;
  event: IEvent;
  type: 'archive' | 'unarchive';
}

export interface UseArchivePanel {
  openArchivePanel: (event: IEvent, type: 'archive' | 'unarchive') => void;
  closeArchivePanel: () => void;
  archivePanelProps: UseArchivePanelProps | undefined;
}

export function useArchivePanel(): UseArchivePanel {
  const [archivePanelProps, setArchivePanelProps] = useState<UseArchivePanelProps | undefined>(
    undefined,
  );

  const closeArchivePanel = useCallback(() => setArchivePanelProps(undefined), []);

  const openArchivePanel = useCallback(
    (event: IEvent, type: 'archive' | 'unarchive') => {
      setArchivePanelProps({
        type,
        event,
        closeArchivePanel,
      });
    },
    [closeArchivePanel],
  );

  return {
    openArchivePanel,
    closeArchivePanel,
    archivePanelProps,
  };
}
